// extracted by mini-css-extract-plugin
export default {"LanguageCircleIndicator":"LanguageCircle-module__LanguageCircleIndicator--eij1J"};